import { create } from 'zustand';

/**
 * ЦЕНТР УВЕЛЕДОМЛЕНИЙ — БУФЕР, А НЕ ВТОРОЙ ТОСТ (VIS-14).
 *
 * Тосты sonner транзиентны: отказ команды промелькнул — и его следа нет,
 * хотя колокол в шапке «обещал» уведомления. Этот стор — накопительный
 * журнал последних событий (успех/отказ/инфо) с непрочитанными; колокол
 * показывает счётчик, поповер — список. Пишут сюда те, кто уже показывает
 * тост (единая точка правды не делится на «тост отдельно, журнал отдельно»).
 */
export type AppNotification = {
  id: string;
  kind: 'success' | 'error' | 'info';
  title: string;
  description?: string;
  at: number;
  read: boolean;
};

const MAX_ITEMS = 50;

type NotificationsState = {
  items: AppNotification[];
  push: (notification: Omit<AppNotification, 'id' | 'at' | 'read'>) => void;
  markAllRead: () => void;
  clear: () => void;
};

export const useNotificationsStore = create<NotificationsState>((set) => ({
  items: [],
  push: (notification) => set((state) => ({
    items: [{
      ...notification,
      id: typeof crypto !== 'undefined' && 'randomUUID' in crypto
        ? crypto.randomUUID()
        : `n-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
      at: Date.now(),
      read: false,
    }, ...state.items].slice(0, MAX_ITEMS),
  })),
  markAllRead: () => set((state) => ({ items: state.items.map((item) => ({ ...item, read: true })) })),
  clear: () => set({ items: [] }),
}));

/** Писать в журнал без подписки — для мест, показывающих тост рядом. */
export function pushNotification(notification: Omit<AppNotification, 'id' | 'at' | 'read'>): void {
  useNotificationsStore.getState().push(notification);
}
